import {
  SectionListFields,
  SectionListProps,
} from "../types/SectionList.types";

export class SectionListModel {
  private readonly fields?: SectionListFields;

  constructor(props: SectionListProps) {
    this.fields = props.fields;
  }

  get layout() {
    return this.fields?.Layout
  }
}
